import React, { useState } from 'react';
import css from './FAQPage.module.css';
import { H3, H4, LayoutSideNavigation, LayoutSingleColumn, Page } from '../../components';
import FooterContainer from '../FooterContainer/FooterContainer';
import TopbarContainer from '../TopbarContainer/TopbarContainer';
import { FaChevronUp, FaChevronDown } from 'react-icons/fa';
import { isScrollingDisabled } from '../../ducks/ui.duck';
import classNames from 'classnames';
// Single source of truth, shared with the chatbot's knowledge retriever
// (server/api/chatbot-retrieval.js) so answers here and in chat cannot drift.
import faqs from '../../config/faqData.json';

const FAQPage = props => {
  const { scrollingDisabled } = props;
  const [acc, setAcc] = useState([]);
  const mainContent = (
    <div>
      {faqs.map(faq => (
        <div className={css.faqcats}>
          <H4>{faq.label}</H4>
          <ul className={css.qnaul}>
            {faq.qna.map(qa => (
              <li>
                <button
                  className={css.accdr}
                  onClick={e => {
                    const isIncl = acc.includes(qa.ques);
                    const ansDiv = document.getElementById(qa.ques);
                    if (isIncl) {
                      setAcc(acc.filter(q => q !== qa.ques));
                      ansDiv.style.maxHeight = null;
                    } else {
                      setAcc([...acc, qa.ques]);
                      ansDiv.style.maxHeight = ansDiv.scrollHeight + 20 + 'px';
                    }
                  }}
                >
                  {qa.ques} {acc.includes(qa.ques) ? <FaChevronUp /> : <FaChevronDown />}
                </button>
                <div
                  id={qa.ques}
                  className={classNames(css.ansp, { [css.showans]: acc.includes(qa.ques) })}
                  dangerouslySetInnerHTML={{ __html: qa.ans }}
                ></div>
              </li>
            ))}
          </ul>
        </div>
      ))}
    </div>
  );
  return (
    <Page title={'FAQ Page'} scrollingDisabled={scrollingDisabled}>
      <LayoutSingleColumn
        topbar={
          <TopbarContainer
            currentPage="FAQPage"
            desktopClassName={css.desktopTopbar}
            mobileClassName={css.mobileTopbar}
          />
        }
        currentPage="FAQPage"
        footer={<FooterContainer />}
      >
        <div className={css.root}>
          <H3 as="h1">FAQs</H3>
          {mainContent}
        </div>
      </LayoutSingleColumn>
    </Page>
  );
};
const mapStateToProps = state => {
  return {
    scrollingDisabled: isScrollingDisabled(state),
  };
};
export default FAQPage;
